var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospitalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hospital-solid 1",
    clipPath: "url(#clip0_2649_666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.4 2.625C8.4 1.17578 9.34062 0 10.5 0H17.5C18.6594 0 19.6 1.17578 19.6 2.625V28H16.1V23.625C16.1 22.1758 15.1594 21 14 21C12.8406 21 11.9 22.1758 11.9 23.625V28H8.4V2.625ZM2.1 5.25H7V28H2.1C0.940625 28 0 26.8242 0 25.375V17.5H3.5C3.885 17.5 4.2 17.1063 4.2 16.625C4.2 16.1437 3.885 15.75 3.5 15.75H0V12.25H3.5C3.885 12.25 4.2 11.8562 4.2 11.375C4.2 10.8938 3.885 10.5 3.5 10.5H0V7.875C0 6.42578 0.940625 5.25 2.1 5.25ZM25.9 5.25C27.0594 5.25 28 6.42578 28 7.875V10.5H24.5C24.115 10.5 23.8 10.8938 23.8 11.375C23.8 11.8562 24.115 12.25 24.5 12.25H28V15.75H24.5C24.115 15.75 23.8 16.1437 23.8 16.625C23.8 17.1063 24.115 17.5 24.5 17.5H28V25.375C28 26.8242 27.0594 28 25.9 28H21V5.25H25.9ZM13.65 3.5C13.265 3.5 12.95 3.89375 12.95 4.375V5.6875H11.9C11.515 5.6875 11.2 6.08125 11.2 6.5625V7.4375C11.2 7.91875 11.515 8.3125 11.9 8.3125H12.95V9.625C12.95 10.1062 13.265 10.5 13.65 10.5H14.35C14.735 10.5 15.05 10.1062 15.05 9.625V8.3125H16.1C16.485 8.3125 16.8 7.91875 16.8 7.4375V6.5625C16.8 6.08125 16.485 5.6875 16.1 5.6875H15.05V4.375C15.05 3.89375 14.735 3.5 14.35 3.5H13.65Z",
    fill: "#6210CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2649_666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalIcon);
export default __webpack_public_path__ + "static/media/hospital_icon.616a0a049d2f7983c11915492c2a16c4.svg";
export { ForwardRef as ReactComponent };